import { css } from '@emotion/react'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        main: (isNested) => {
            return css`
                ${custom.stepTextPadding};
                ${isNested ? 'padding-right: 0;' : ''}
            `
        },
        title: (isRequired, isAnswered) => {
            return css`
            ${custom.stepElementPadding};
            padding: 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            ${custom.dialogTitle};
            ${custom.stepText};
            border-bottom-left-radius: 0;
            ${!isAnswered && !isRequired ? custom.optionalStepText : ''};
            ${!isAnswered && isRequired ? custom.mandatoryStepText : ''};
        `
        },
        titleText: custom.messageText,
        childborder: (isRequired, isAnswered) => {
            return css`
            ${custom.stepBorder};
            border-right-width: 0;
            border-top-width: 0;
            border-radius: 5px;
            border-top-left-radius: 0;
            ${!isAnswered && !isRequired ? custom.optionalStepBorder : ''};
            ${!isAnswered && isRequired ? custom.mandatoryStepBorder : ''};
        `
        },
        stateText: css`
            align-self: flex-end;
        `,
    }
}

export default styles
